import React, { Fragment, useContext, useState } from "react";
import DataTable from "react-data-table-component";
import { packagesColumns, packagesRateColumns } from "../../Data/Configuration/Packages";
import { DropdownItem } from "reactstrap";
import ActionOptions from "../Common/Component/ActionOptions";
import { Spinner } from "../../AbstractElements";
import CommonToolTip from "../Common/Component/CommonToolTip";
import CustomizerContext from "../../_helper/Customizer";

const PackagesRateTable = ({
    tableData,
    setShowApiLoader,
    fetchTableData,
    paginationPerPage,
    paginationTotalRows,
    onChangePage,
    onChangeRowsPerPage,
    onEditClick,
    loader
}) => {
    const {mix_background_layout} = useContext(CustomizerContext)
    const[openModal,setOpenModal] = useState(true)
    const processData = tableData.map((element, index) => {
        return {
            pkgDistance: element.pkgDistance ? element.pkgDistance : "-",
            minPkgDistance: element.minPkgDistance ? element.minPkgDistance : "-",
            maxPkgDistance: element.maxPkgDistance ? element.maxPkgDistance : "-",
            isTaxInclusive: element.isTaxInclusive ? "true" : "false",
            isTimeBased: element.isTimeBased ? "true" : "false",
            timeFrom: element.timeFrom ? `${Math.floor(element.timeFrom / 3600)}H` : "-",
            timeTo: element.timeTo ? `${Math.floor(element.timeTo / 3600)}H` : "-",
            isAirportDropPackage: element.isAirportDropPackage ? "true" : "false",
            isNightfareTimeSlot: element.isNightfareTimeSlot ? "true" : "false",
            pkgTimeInMin: element.pkgTimeInMin ? element.pkgTimeInMin : "-",
            pkgCharge: element.pkgCharge ? element.pkgCharge : "-",
            addnlPerKmCharge: element.addnlPerKmCharge ? element.addnlPerKmCharge : "-",
            addnlTimeCharge: element.addnlTimeCharge ? element.addnlTimeCharge : "-",
            addnlTimeChargeBlockInMin: element.addnlTimeChargeBlockInMin ? element.addnlTimeChargeBlockInMin : "-",
            packageValue: element.packageValue ? element.packageValue : "-",
            packageRideType: element.packageRideType ? element.packageRideType : "-",
            packagesName: element.packagesName || element.packages?.name ? <>
                <span
                    id={"packagesName" + index}
                    style={{
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                    }}
                >
                    {element.packagesName  || element.packages?.name}
                </span>
                <CommonToolTip
                    options={{
                        placement: "bottom",
                        target: "packagesName" + index,
                    }}
                >
                    {element.packagesName  || element.packages?.name}
                </CommonToolTip>
            </> : "-",
            action: (
                <div style={{position:"relative",zIndex:"99999"}}>
                <ActionOptions key={index}>
                    <Fragment>
                        <DropdownItem
                            className="border-0"
                            key={"row-edit"}
                            onClick={() => {
                                console.log("edit clicked");
                                onEditClick(element)}}
                        >
                            <i className="fa fa-pencil"></i> Edit
                        </DropdownItem>
                    </Fragment>
                </ActionOptions>
                </div>
            ),
        };
    });
    return (
        <div >
            <div className="table-responsive">
                <DataTable
                    columns={packagesRateColumns}
                    data={processData}
                    center={true}
                    fixedHeader
                    fixedHeaderScrollHeight={"57vh"}
                    pagination
                    paginationPerPage={paginationPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    // customStyles={customStyles}
                    paginationServer
                    progressPending={loader}
                    progressComponent={<div className="loader-box" style={{ height: "57vh" }}>
                        <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
                    </div>}
                    theme={mix_background_layout == "dark-only" ? "dark" : "default"}
                />
            </div>
           
        </div>
    );
};

export default PackagesRateTable;
